import { useDialogs } from "@/context";
import React from "react";
import {
  ConfirmDialog,
  CloneAudienceDialog,
  CreateAudienceDialog,
  DeleteActivationDialog,
  DeleteAudienceDialog,
  EditAudienceDialog,
  SelectAudienceDialog,
  ShareAudienceDialog,
  ShareDialog,
  UnshareAudienceDialog,
  VariableSearchDialog,
} from ".";

const DialogRoot: React.FC = () => {
  const { dialog, closeDialog } = useDialogs();

  if (!dialog) return null;

  switch (dialog.type) {
    case "confirm":
      return (
        <ConfirmDialog
          open={true}
          message={dialog.props.message}
          onClose={closeDialog}
          onConfirm={() => {
            dialog.props.onConfirm();
            closeDialog();
          }}
        />
      );
    case "deleteAudience":
      return (
        <DeleteAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "editAudience":
      return (
        <EditAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "shareAudience":
      return (
        <ShareAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "shareActivation":
      return (
        <ShareDialog
          open={true}
          onClose={closeDialog}
          entityType="Activation"
          {...dialog.props}
        />
      );
    case "createAudience":
      return (
        <CreateAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "cloneAudience":
      return (
        <CloneAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "unshareAudience":
      return (
        <UnshareAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "deleteActivation":
      return (
        <DeleteActivationDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "selectAudience":
      return (
        <SelectAudienceDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    case "variableSearch":
      return (
        <VariableSearchDialog
          open={true}
          onClose={closeDialog}
          {...dialog.props}
        />
      );
    default:
      return null;
  }
};

export default DialogRoot;
